import React, { useEffect, useState } from 'react'
import './CountryDetail.css'
import { Link, useLocation, useOutletContext, useParams } from 'react-router-dom'

import CountryDetaileShimmer from './CountryDetaileShimmer'
import CountryNotFound from './CountryNotFound'

export default function CountryDetail() {
  // const countryName = new URLSearchParams(location.search).get('name')
  const params = useParams()
  const { state } = useLocation()
  const countryName = params.Country
  const [isDark] = useOutletContext()

  const [countryData, setCountryData] = useState(null)
  const [notFound, setNotFound] = useState(false)

  // console.log('level')
  // console.log(countryData);

  function updateCountryData(data) {
    const languagesArr = Object.values(data.languages);
    let languages = "";

    if (languagesArr.length >= 6) {
      languages = languagesArr.slice(0, 5).join(', ') + ", etc.";
    } else {
      languages = languagesArr.join(', ');
    }

    setCountryData({
      name: data.name.common,
      nativeName: Object.values(data.name.nativeName)[0].common,
      population: data.population,
      region: data.region,
      subregion: data.subregion,
      capital: data.capital,
      flag: data.flags.svg,
      tld: data.tld,
      languages: languages,
      currencies: Object.values(data.currencies)
        .map((currency) => currency.name)
        .join(', '),
      borders: [],
    });

    if (!data.borders) {
      data.borders = [];
    }

    Promise.all(
      data.borders.map((border) => {
        return fetch(`https://restcountries.com/v3.1/alpha/${border}`)
          .then((res) => res.json())
          .then(([borderCountry]) => borderCountry.name.common);
      })
    ).then((borders) => {
      setTimeout(() => setCountryData((prevState) => ({ ...prevState, borders })))
    });
  }


  useEffect(() => {
    if (state) {
      updateCountryData(state)
      return
    }

    fetch(`https://restcountries.com/v3.1/name/${countryName}?fullText=true`)
      .then((res) => res.json())
      .then(([data]) => {
        updateCountryData(data)
      })
      .catch((err) => {
        console.log(err)
        setNotFound(true)
      })
  }, [countryName])


  if (notFound) {
    return <CountryNotFound />
  }
  else if (countryData === null) {
    return <CountryDetaileShimmer />
  } else {
    return (
      <>
        {/* <CountryDetaileShimmer /> */}
        <main className={`${isDark ? 'dark' : ''}`}>
          <div className="country-details-container">
            <span className="back-button" onClick={() => history.back()}>
              <i className="fa-solid fa-arrow-left"></i>&nbsp; Back
            </span>
            <div className="country-details">
              <img src={countryData.flag} alt={`${countryData.name} flag`} />
              <div className="details-text-container">
                <h1 style={{ backgroundColor: "transparent" }}>{countryData.name}</h1>
                <div className="details-text">
                  <p>
                    <b>Native Name: {countryData.nativeName}</b>
                    <span className="native-name"></span>
                  </p>
                  <p>
                    <b>
                      Population: {countryData.population.toLocaleString('en-IN')}
                    </b>
                    <span className="population"></span>
                  </p>
                  <p>
                    <b>Region: {countryData.region}</b>
                    <span className="region"></span>
                  </p>
                  <p>
                    <b>Sub Region: {countryData.subregion}</b>
                    <span className="sub-region"></span>
                  </p>
                  <p>
                    <b>Capital: {countryData.capital.join(', ')}</b>
                    <span className="capital"></span>
                  </p>
                  <p>
                    <b>Top Level Domain: {countryData.tld}</b>
                    <span className="top-level-domain"></span>
                  </p>
                  <p>
                    <b>Currencies: {countryData.currencies}</b>
                    <span className="currencies"></span>
                  </p>
                  <p className='wrapper'>
                    <b>Languages: {countryData.languages}</b>
                    <span className="languages"></span>
                  </p>
                </div>
                {countryData.borders.length !== 0 && <div className="border-countries">
                  <b>Border Countries: </b>&nbsp;
                  {countryData.borders.map((border) => {
                    return <Link key={border} to={`/${border}`}>{border}</Link>
                  })}
                </div>}
              </div>
            </div>
          </div>
        </main>
      </>
    )
  }

}


